// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JavascriptRequired{background-color:#c00;border-radius:.125rem;color:#fff;margin-bottom:.5rem;padding:2rem;text-align:center}.JavascriptRequired>.Title{color:#fff}.JavascriptRequired>div{margin-left:auto;margin-right:auto;max-width:70ch}.JavascriptRequired a{color:#fff;-webkit-text-decoration:underline;text-decoration:underline}.JavascriptRequired a:focus,.JavascriptRequired a:hover{color:#fff;-webkit-text-decoration:none;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
